import { useEffect, useState } from 'react'
import { useBlocksIntersectionWhenScrollingDown, useScrollDirection } from '@/utils/hooks'
import { EIntersectionState } from './constants'
import { pushGtmEvent } from './helpers'
import type { IFormattedGtmEventPayload, IUsePushScrollGtmEventOptions } from './interfaces'

export const usePushScrollGtmEvent = <T extends string, G>(options: IUsePushScrollGtmEventOptions<T, G>) => {
  const { scrollDirection } = useScrollDirection({ className: '' })

  const { blockIds, gtmScrollEventPayloads, isFitsFullScreen } = options

  const intersectedBlockId = useBlocksIntersectionWhenScrollingDown({
    blockIds,
    scrollDirection,
    isFitsFullScreen,
  }) as T

  const initialIntersectedBlocksState = blockIds.reduce(
    (state, blockId) => {
      return { ...state, [blockId]: EIntersectionState.didNotIntersect }
    },
    {} as Record<T, EIntersectionState>,
  )

  const [intersectedBlocks, setIntersectedBlocks] = useState(initialIntersectedBlocksState)

  useEffect(() => {
    const eventPayload = gtmScrollEventPayloads[intersectedBlockId]

    if (eventPayload && intersectedBlocks[intersectedBlockId] === EIntersectionState.didNotIntersect) {
      pushGtmEvent<G | IFormattedGtmEventPayload>(eventPayload)
      setIntersectedBlocks({ ...intersectedBlocks, [intersectedBlockId]: EIntersectionState.intersected })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intersectedBlockId])

  return {
    setIntersectedBlocks,
  }
}
